/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scl_Nav_Stock_In_NotesInputs */

const vi_scl_nav_stock_in_notes = /** @type {(inputs: Scl_Nav_Stock_In_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phiếu nhập`)
};

/**

* @param {Scl_Nav_Stock_In_NotesInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const scl_nav_stock_in_notes = /** @type {((inputs?: Scl_Nav_Stock_In_NotesInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scl_Nav_Stock_In_NotesInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_scl_nav_stock_in_notes(inputs)
});